export default {
  colors: {
    default: '#344675',
    primary: '#42b883',
    info: '#1d8cf8',
    danger: '#fd5d93',
    orange: '#ff8a76',
    teal: '#00d6b4',
    // primaryGradient: [
    //   'rgba(76, 211, 150, 0.1)',
    //   'rgba(53, 183, 125, 0)',
    //   'rgba(119,52,169,0)'
    // ],
    primaryGradient: [
      'rgba(21, 207, 121, 1)',
      'rgba(21, 207, 121, 1)',
      'rgba(21, 207, 121, 1)'
    ],
    purpleGradient: ['rgba(52,149,198,0.8)', 'rgba(239,240,241,0)']
  }
};
